<template>
  <b-modal
    ref="bModal"
    :title="$t('registry.btn.printCustomLabels')"
    centered
    size="sm"
    modal-class="modalCustomPrint"
    @hide="onHide"
  >
    <b-row>
      <b-col>
        <div class="box full-bordered case py-2 px-3 d-flex justify-content-between">
          <div class="d-flex align-items-center">
            <b-form-checkbox
              id="case-check"
              v-model="caseSelectedToPrint"
              name="case-check"
            >
              <i
                class="far fa-chart-network main mx-2"
                aria-hidden="true"
              /><span class="label-dark">{{ $tc('global.case',1) }}</span>
            </b-form-checkbox>
          </div>
          <div class="d-flex align-items-center input-col">
            <label>{{ $t('global.quantity') }}</label>
            <vt-input
              v-model="caseQuantityToPrint"
              type="number"
              size="sm"
            />
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div class="box full-bordered sample py-2 px-3 d-flex justify-content-between flex-column">
          <div class="d-flex align-items-center mb-2">
            <b-form-checkbox
              id="sample-check"
              v-model="selectAll"
              name="sample-check"
              @change="toggleAll"
            >
              <i
                class="far fa-prescription-bottle main mx-2"
                aria-hidden="true"
              /><span class="label-dark">{{ $tc('global.sample',2) }}</span>
            </b-form-checkbox>
          </div>
          <div class="section-scrollable">
            <div
              v-for="(sample, index) in samples"
              :key="index"
              class="d-flex justify-content-between sample-row"
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  :id="index | abc"
                  v-model="sample.selectedForPrint"
                  name="case-check"
                >
                  <span class="mx-3 label-dark">{{ sample.sampleNumber }}</span>
                </b-form-checkbox>
              </div>
              <div class="d-flex align-items-center input-col">
                <label>{{ $t('global.quantity') }}</label>
                <vt-input
                  v-model="sample.copies"
                  type="number"
                  size="sm"
                />
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <vt-loading-button
            class="btn--primary btn-sm"
            :disabled="!caseSelectedToPrint && !samples.filter((sample) => sample.selectedForPrint).length"
            :params="{ promise: print }"
          >
            <i
              class="fal fa-print mr-2"
              aria-hidden="true"
            />
            {{ $t('global.print') }}
          </vt-loading-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { cloneDeep } from 'lodash'
export default {
    name: 'ModalCustomPrint',
    data() {
        return {
            samples: [],
            caseQuantityToPrint: 1,
            caseSelectedToPrint: false,
            selectAll: false
        }
    },
    methods: {
        onHide() {
            this.$_cleanComponentData()
        },
        show(samples) {
            this.samples = cloneDeep(samples)
            this.samples.forEach(sample => {
                sample.copies = 1
            })
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        toggleAll() {
            this.$nextTick(() => {
                this.samples.forEach((sample) => {
                    sample.selectedForPrint = this.selectAll
                })
                this.$forceUpdate()
            })
        },
        print() {
            const samplesToPrint = this.samples.filter((sample) => sample.selectedForPrint)
            const customPrintData = { samplesToPrint }
            if (this.caseSelectedToPrint) {
                customPrintData.caseQuantityToPrint = this.caseQuantityToPrint
            }
            this.$emit('handleCustomPrint', customPrintData)
            this.hide()
        }
    }
}
</script>

<style lang="scss">

.modalCustomPrint .box i {
  width: 20px;
  text-align: center;
}

.modalCustomPrint .box span {
  color: vt-color(dark-text);
}

.modalCustomPrint .box.case {
  border-bottom: 0;
  border-radius: 3px 3px 0 0;
}

.modalCustomPrint .box.sample {
  border-radius: 0 0 3px 3px;
  background: vt-color(light-grey, .95);
}

.modalCustomPrint .box .input-col input {
  width: 70px;
}

.modalCustomPrint .box .input-col label{
  margin: 0 5px;
  font-size: font-size(small);
}

.modalCustomPrint .sample-row {
  border-bottom: 1px solid vt-color(light-grey);
  padding: 3px 0;
}

.modalCustomPrint .sample-row:last-child {
  border-bottom: 0;
}

.modalCustomPrint .section-scrollable{
  max-height: 25vh;
  overflow: auto;
  padding-right: 2px;
}

@media (max-width: 1300px) {

}
</style>
